import React from "react";
import Slider from "../../../common/Slider";
import Icon from "../../../common/Icon";
import PropTypes from "prop-types";
import memoizeOne from "memoize-one";
import S from "../../../styles/components";
import connectToMedia from "../../Media/connectToMedia";
import TimeLabel from "../../Labels/TimeLabel";
import { get } from "lodash";
import Badge from "../../../common/Badge";
import Button from "../../../common/Button";
import ToolTip from "../../../common/ToolTip";
import Circle from "../../../assets/icons/circle.gif";
import VoicebaseReactPlayerContext from "../../../VoicebaseReactPlayerContext";
import playNextPreviousMedia from "../utils/playNextPreviousMedia";

const mapStateToProps = (state) => ({ ...state.media, queries: state.query });
const ProgressSpeed = [1, 1.25, 1.5, 1.75, 2];
class ProgressControls extends React.PureComponent {
  static contextType = VoicebaseReactPlayerContext;

  constructor(props) {
    super(props);
    this.state = {
      isSpeedTooltipVisible: false,
      speedValue: 1,
      skipBackColor: "#677791",
      skipForwardColor: "#677791",
      backColor: "#677791",
      nextColor: "#677791",
      onHoverPlay: true,
    };
  }
  static propTypes = {
    duration: PropTypes.number,
    currentTime: PropTypes.number,
    children: PropTypes.node,
    mediaElement: PropTypes.instanceOf(Element),
    mediaId: PropTypes.string,
    messagesDuration: PropTypes.number,
  };

  static defaultProps = {
    queries: [],
  };

  seek = (value) => {
    const { onSeek, duration } = this.props;
    onSeek({ s: value });
  };

  renderTooltip(value) {
    return <TimeLabel ms={value} />;
  }

  getHitMarks = memoizeOne((queries) =>
    []
      .concat(...queries.map((query) => query.hits))
      .reduce(
        (acc, hit) => ({ ...acc, [get(hit, "s", [])]: <S.ProgressMark /> }),
        {}
      )
  );
  play = () => {
    const { onPlay } = this.props;
    this.setState({ onHoverPlay: true });
    onPlay();
  };
  pause = () => {
    const { onPause } = this.props;
    onPause();
  };
  skipForward = () => {
    const { onSeek, duration, currentTime } = this.props;
    const skipTime = currentTime + 15000; // currentTime + (duration / 20);
    onSeek({ s: skipTime > duration ? duration : skipTime });
  };

  skipBackward = () => {
    const { onSeek, duration, currentTime } = this.props;
    const skipTime = currentTime - 15000; // currentTime - (duration / 20);
    onSeek({ s: skipTime < 0 ? 0 : skipTime });
  };
  skipToStart = () => {
    const { onSeek } = this.props;
    onSeek({ s: 0 });
  };
  skipToEnd = () => {
    const { onSeek, duration } = this.props;
    onSeek({ s: duration });
  };

  addWordSearchedClass = (i) => {
    if (document.querySelector(`.word-index-${i}`)) {
      document.querySelector(`.word-index-${i}`).classList.add("word-searched");
    }
  };

  removeWordSearchedClass = () => {
    const allElements = document.querySelectorAll(".word-searched");
    allElements.forEach((element) => {
      element.classList.remove("word-searched");
    });
  };

  skipToNextHit = (event) => {
    const { queries, currentTime, currentPosition, onSeek, onSkipPrevNextHit } =
      this.props;
    const hits = this.getHits(queries);

    const hit =
      hits.find((hit) => {
        if (hit.s) {
          return hit.s > Math.ceil(currentTime);
        }
        return hit.p > Math.ceil(currentPosition);
      }) || hits[0];

    if (hit) {
      onSeek(hit);
      onSkipPrevNextHit(true);
      this.removeWordSearchedClass();
      this.addWordSearchedClass(hit.p);
    }
  };

  changeVolume = (value) => {
    const { onVolume } = this.props;

    onVolume(value / 100);
  };
  clickOnVolume = () => {
    const { onVolume, volume } = this.props;
    if (volume > 0) {
      onVolume(0 / 100);
    } else {
      onVolume(50 / 100);
    }
  };

  getHits = memoizeOne((queries) =>
    [].concat(...queries.map((query) => query.hits)).sort((a, b) => a.s - b.s)
  );
  onVisibleChangeForSelectSpeedTooltip = (isSpeedTooltipVisible) => {
    this.setState({
      isSpeedTooltipVisible,
    });
  };
  setProgressControlIcon(name) {
    switch (name) {
      case "Play":
        return (
          <svg
            width="62"
            height="62"
            viewBox="0 0 62 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M31 54.25C43.8406 54.25 54.25 43.8406 54.25 31C54.25 18.1594 43.8406 7.75 31 7.75C18.1594 7.75 7.75 18.1594 7.75 31C7.75 43.8406 18.1594 54.25 31 54.25Z"
              fill="#339EEC"
              stroke="#339EEC"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M38.75 31L27.125 23.25V38.75L38.75 31Z"
              fill="white"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        break;
    }
  }
  setSpeedValue(speed) {
    this.setState({
      speedValue: speed,
    });
  }
  setPlaybackSpeed = (speed) => {
    const { onPlaybackSpeedChange } = this.props;
    this.setSpeedValue(speed);
    onPlaybackSpeedChange(speed);
  };
  selectedSpeed() {
    return (
      <div style={{ display: "grid" }} className="player-speed">
        {ProgressSpeed.map((speed) => (
          <S.ProgressSpeedButton
            onClick={() => this.setPlaybackSpeed(speed)}
            active={speed === this.state.speedValue}
          >
            {speed}
          </S.ProgressSpeedButton>
        ))}
      </div>
    );
  }

  render() {
    const {
      currentTime = 0,
      duration = 0,
      mediaId,
      queries,
      readyState,
      volume,
      paused,
      isTimeLineVisible,
      setTimelineVisibility,
      playbackRate,
      isChatTextMedia,
      messagesDuration,
    } = this.props;

    const { isHostedApp = false } = this.context;

    const hitCount = queries.reduce(
      (acc, query) => get(query, "hits.length", 0) + acc,
      0
    );
    const loading = readyState < 2;

    const previousNextButtons = (style = {}) => (
      <div style={{ ...style, display: "flex" }}>
        <S.ProgressIconStyle>
          <ToolTip
            key={`Previous`}
            placement="bottom"
            trigger={["hover"]}
            overlay={<span>Previous</span>}
            style={{ minHeight: "auto" }}
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onMouseOver={() => this.setState({ backColor: "#262D38" })}
              onMouseLeave={() => this.setState({ backColor: "#677791" })}
              onClick={() => {
                playNextPreviousMedia({
                  ...this.context,
                  mediaId,
                  nextOrPrevious: "previous",
                });
              }}
            >
              <path
                d="M14.5 8.64697L4.5 8.64697"
                stroke={this.state.backColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="demo1"
              />
              <path
                d="M9.00049 4.14697L4.50049 8.64697L9.00049 13.147"
                stroke={this.state.backColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="demo1"
              />
              <path
                d="M2.5 3.64697L2.5 13.647"
                stroke={this.state.backColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="demo1"
              />
            </svg>
          </ToolTip>
        </S.ProgressIconStyle>
        <S.ProgressIconStyle>
          <ToolTip
            key={`Next`}
            placement="bottom"
            trigger={["hover"]}
            overlay={<span>Next</span>}
            style={{ minHeight: "auto" }}
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onMouseOver={() => this.setState({ nextColor: "#262D38" })}
              onMouseLeave={() => this.setState({ nextColor: "#677791" })}
              onClick={() => {
                playNextPreviousMedia({
                  ...this.context,
                  mediaId,
                  nextOrPrevious: "next",
                });
              }}
            >
              <path
                d="M1.5 8.64697H11.5"
                stroke={this.state.nextColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.99951 13.147L11.4995 8.64697L6.99951 4.14697"
                stroke={this.state.nextColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.5 13.647V3.64697"
                stroke={this.state.nextColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ToolTip>
        </S.ProgressIconStyle>
      </div>
    );

    return isChatTextMedia ? (
      <S.Progress>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {!isHostedApp &&
            previousNextButtons({
              alignSelf: "flex-end",
              margin: "1rem",
            })}
          <S.ProgressIconStyle
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginLeft: "unset",
              // textAlign: "right",
            }}
          >
            <Slider
              disabled={isChatTextMedia}
              horizontal
              min={0}
              max={messagesDuration}
              marks={this.getHitMarks(queries)}
              value={currentTime}
              tipFormatter={this.renderTooltip}
              onChange={this.seek} // TODO: use a method call
              style={{ margin: 5, flex: 1 }}
              dotStyle={{ display: "none" }}
            />
            <ToolTip
              key={`Skip to Next`}
              placement="bottom"
              trigger={["hover"]}
              overlay={<span>Skip to Next Hit</span>}
              style={{ minHeight: "auto" }}
            >
              <div class="next-hit-button-container messages-player">
                {this.getHits(queries).length ? (
                  <Badge dot>
                    <Button
                      onClick={this.skipToNextHit}
                      shape="circle"
                      icon="history"
                      size="sm"
                    />
                  </Badge>
                ) : (
                  <Button shape="circle" icon="history" disabled size="sm" />
                )}
              </div>
            </ToolTip>
            <ToolTip
              // placement="left"
              trigger={["hover"]}
              overlay={<span>Toggle speaker sentiment timeline</span>}
              style={{ minHeight: "auto" }}
            >
              <Button
                shape="circle"
                size="sm"
                onClick={() => setTimelineVisibility()}
                icon={isTimeLineVisible ? "up" : "down"}
                style={{
                  border: "2px solid #677791",
                }}
              />
            </ToolTip>
          </S.ProgressIconStyle>
        </div>
      </S.Progress>
    ) : (
      <S.Progress>
        {/*
        <S.ProgressHeader>
          <S.ProgressLabel><TimeLabel ms={currentTime} /></S.ProgressLabel>
          <S.ProgressLabel style={{ fontWeight: 'bold' }}>{label}</S.ProgressLabel>
          <S.ProgressLabel><TimeLabel ms={duration} /></S.ProgressLabel>
        </S.ProgressHeader>
        */}
        <S.ProgressControl>
          <S.ProgressIcon style={{ minHeight: "60px", minWidth: "65px" }}>
            {paused ? (
              <span style={{ minWidth: "65px" }}>
                <ToolTip
                  key={`Play`}
                  placement="bottom"
                  trigger={["hover"]}
                  overlay={<span>Play</span>}
                  style={{ minHeight: "auto" }}
                >
                  <Button
                    type="primary"
                    onClick={this.play}
                    loading={loading}
                    disabled={loading}
                    shape="circle"
                    size="lg"
                    icon="caret-right"
                    style={{ marginTop: "5px" }}
                  />
                </ToolTip>
              </span>
            ) : (
              <span
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                  minWidth: "65px",
                }}
              >
                {this.state.onHoverPlay ? (
                  <span>
                    <ToolTip
                      key={`Pause`}
                      placement="bottom"
                      trigger={["hover"]}
                      overlay={<span>Pause</span>}
                      style={{ minHeight: "auto" }}
                    >
                      <img
                        src={Circle}
                        alt="loading..."
                        className="player-content"
                        onClick={this.pause}
                        loading={loading}
                        disabled={loading}
                        onMouseOver={() =>
                          this.setState({ onHoverPlay: false })
                        }
                        style={{ marginTop: "5px" }}
                      />
                    </ToolTip>
                  </span>
                ) : (
                  <span className="mini-player-button">
                    <ToolTip
                      key={`Pause`}
                      placement="bottom"
                      trigger={["hover"]}
                      overlay={<span>Pause</span>}
                      style={{ minHeight: "auto" }}
                    >
                      <Button
                        icon="pause"
                        type="primary"
                        size="lg"
                        shape="circle"
                        onClick={this.pause}
                        loading={loading}
                        disabled={loading}
                        onMouseLeave={() =>
                          this.setState({ onHoverPlay: true })
                        }
                        style={{ marginRight: "0px", marginTop: "5px" }}
                      />
                    </ToolTip>
                  </span>
                )}
              </span>
            )}
          </S.ProgressIcon>
          <S.ProgressTime style={{ display: "flex" }}>
            <div
              style={{
                // minWidth: "55px",
                // textAlign: "right",
                marginRight: "2px",
              }}
            >
              <TimeLabel ms={currentTime} />
            </div>{" "}
            / <TimeLabel ms={duration} />
          </S.ProgressTime>
          <S.ProgressSpeed>
            <ToolTip
              key="flagCall"
              placement="bottom"
              trigger={["click"]}
              visible={this.state.isSpeedTooltipVisible}
              onVisibleChange={this.onVisibleChangeForSelectSpeedTooltip}
              overlay={<span>{this.selectedSpeed()}</span>}
            >
              <ToolTip
                key={`Adjust Speed`}
                placement="bottom"
                trigger={["hover"]}
                overlay={<span>Adjust Speed</span>}
                style={{ minHeight: "auto" }}
              >
                <S.ProgressSpeedText>
                  <span style={{ minWidth: "25px", textAlign: "right" }}>
                    {this.state.speedValue}
                  </span>
                  <span>x</span>
                  <span style={{ marginTop: "5px", marginLeft: "1px" }}>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.75 4.5L6 8.25L2.25 4.5"
                        stroke="#677791"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="caret-down"
                      />
                    </svg>
                  </span>
                </S.ProgressSpeedText>
              </ToolTip>
            </ToolTip>
          </S.ProgressSpeed>

          <S.ProgressIconStyle>
            <ToolTip
              key={`Rewind`}
              placement="bottom"
              trigger={["hover"]}
              overlay={<span>Rewind</span>}
              style={{ minHeight: "auto" }}
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={this.skipBackward}
                onMouseOver={() => this.setState({ skipBackColor: "#262D38" })}
                onMouseLeave={() => this.setState({ skipBackColor: "#677791" })}
              >
                <path
                  d="M4.98975 6.48218H1.98975V3.48218"
                  stroke={this.state.skipBackColor}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  // id="skip-back-icon"
                />
                <path
                  d="M4.11107 12.1391C4.88025 12.9083 5.86026 13.4321 6.92716 13.6443C7.99405 13.8565 9.09992 13.7476 10.1049 13.3313C11.1099 12.9151 11.9689 12.2101 12.5732 11.3056C13.1776 10.4012 13.5002 9.3378 13.5002 8.25C13.5002 7.16221 13.1776 6.09884 12.5732 5.19437C11.9689 4.2899 11.1099 3.58495 10.1049 3.16867C9.09992 2.75238 7.99405 2.64346 6.92716 2.85568C5.86026 3.0679 4.88025 3.59173 4.11107 4.36092L1.98975 6.48224"
                  stroke={this.state.skipBackColor}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  // id="skip-back-icon"
                />
              </svg>
            </ToolTip>
          </S.ProgressIconStyle>
          <S.ProgressIconStyle>
            <ToolTip
              key={`Fast Forward`}
              placement="bottom"
              trigger={["hover"]}
              overlay={<span>Fast Forward</span>}
              style={{ minHeight: "auto" }}
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={this.skipForward}
                onMouseOver={() =>
                  this.setState({ skipForwardColor: "#262D38" })
                }
                onMouseLeave={() =>
                  this.setState({ skipForwardColor: "#677791" })
                }
              >
                <path
                  d="M11.0103 6.48218H14.0103V3.48218"
                  stroke={this.state.skipForwardColor}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.8891 12.1391C11.1199 12.9083 10.1399 13.4321 9.073 13.6443C8.0061 13.8565 6.90023 13.7476 5.89524 13.3313C4.89025 12.9151 4.03126 12.2101 3.42692 11.3056C2.82257 10.4012 2.5 9.3378 2.5 8.25C2.5 7.16221 2.82257 6.09884 3.42692 5.19437C4.03126 4.2899 4.89025 3.58495 5.89524 3.16867C6.90023 2.75238 8.0061 2.64346 9.073 2.85568C10.1399 3.0679 11.1199 3.59173 11.8891 4.36092L14.0104 6.48224"
                  stroke={this.state.skipForwardColor}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </ToolTip>
          </S.ProgressIconStyle>
          <S.ProgressIconStyle>
            <ToolTip
              key={`Skip to Next`}
              placement="bottom"
              trigger={["hover"]}
              overlay={<span>Skip to Next Hit</span>}
              style={{ minHeight: "auto" }}
            >
              <div class="next-hit-button-container">
                {this.getHits(queries).length ? (
                  <Badge dot>
                    <Button
                      onClick={this.skipToNextHit}
                      shape="circle"
                      icon="history"
                      size="sm"
                    />
                  </Badge>
                ) : (
                  <Button shape="circle" icon="history" disabled size="sm" />
                )}
              </div>
            </ToolTip>
          </S.ProgressIconStyle>
          <S.ProgressIconStyle
            style={{ whiteSpace: "nowrap", paddingLeft: "8px" }}
          >
            <ToolTip
              key={`Volume`}
              placement="bottom"
              trigger={["hover"]}
              overlay={<span>Volume</span>}
              style={{ minHeight: "auto" }}
            >
              {volume === 0 ? (
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => this.clickOnVolume()}
                >
                  <path
                    d="M3.5 3.06543L13.5 14.0654"
                    stroke="#677791"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.50928 4.50255L9.9999 2.56543V7.24224"
                    stroke="#677791"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10 10.2154V14.5654L5.5 11.0654H2.5C2.36739 11.0654 2.24021 11.0128 2.14645 10.919C2.05268 10.8252 2 10.698 2 10.5654V6.56543C2 6.43282 2.05268 6.30564 2.14645 6.21188C2.24021 6.11811 2.36739 6.06543 2.5 6.06543H6.22727"
                    stroke="#677791"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => this.clickOnVolume()}
                >
                  <path
                    d="M5 10.75H2C1.86739 10.75 1.74021 10.6973 1.64645 10.6036C1.55268 10.5098 1.5 10.3826 1.5 10.25V6.25C1.5 6.11739 1.55268 5.99021 1.64645 5.89645C1.74021 5.80268 1.86739 5.75 2 5.75H5L9.5 2.25V14.25L5 10.75Z"
                    stroke={volume > 0 ? "black" : "#677791"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5 5.75V10.75"
                    stroke={volume > 0 ? "black" : "#677791"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </ToolTip>

            <Slider
              style={{
                display: "inline-block",
                width: "110px",
                margin: "0",
                marginLeft: "10px",
                marginBottom: "5px",
              }}
              min={0}
              max={100}
              step={1}
              value={volume * 100}
              onChange={this.changeVolume} // TODO: use a method call
            />
          </S.ProgressIconStyle>
          {!isHostedApp &&
            previousNextButtons({ position: "absolute", right: "35px" })}
        </S.ProgressControl>

        <S.ProgressSlider style={{ display: "inline-flex", width: "100%" }}>
          <Slider
            horizontal
            min={0}
            max={duration}
            marks={this.getHitMarks(queries)}
            value={currentTime}
            tipFormatter={this.renderTooltip}
            onChange={this.seek} // TODO: use a method call
            style={{ margin: 5, flex: 1 }}
            dotStyle={{ display: "none" }}
          />
          {/* <div style={{ flex: 'none' }}>
            <Button shape="circle" size="sm" onClick={this.skipToPrevHit} icon="up" />
          </div> */}
          {!!queries.length && (
            <div>
              <S.ProgressEventMark>
                <Icon type="clock-circle" theme="filled" /> {hitCount}
              </S.ProgressEventMark>
            </div>
          )}

          <ToolTip
            trigger={["hover"]}
            overlay={<span>Toggle speaker sentiment timeline</span>}
            style={{ minHeight: "auto" }}
          >
            {isTimeLineVisible ? (
              <div style={{ padding: "0 4px", flex: "none" }}>
                <Button
                  shape="circle"
                  size="sm"
                  onClick={() => setTimelineVisibility()}
                  icon="up"
                  style={{ border: "2px solid #677791" }}
                />
              </div>
            ) : (
              <div style={{ padding: "0 4px", flex: "none" }}>
                <Button
                  shape="circle"
                  size="sm"
                  onClick={() => setTimelineVisibility()}
                  icon="down"
                  style={{ border: "2px solid #677791" }}
                />
              </div>
            )}
          </ToolTip>
        </S.ProgressSlider>
      </S.Progress>
    );
  }
}

export default connectToMedia(mapStateToProps)(ProgressControls);
